export default {"src":"/_next/static/media/sailing-together-sm.mono.5a6fc3c2.svg","height":374,"width":408,"blurWidth":0,"blurHeight":0};